import { Component, Inject, NgZone, ChangeDetectorRef, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';
import { Geocoder, GeocoderResult, GeocoderStatus, CoordinateType, Geometry } from './ovs.geocoding';

@Component({
    selector: 'geocoder-result-detail',
    templateUrl: './geocoder-result-detail.component.html',
    styleUrls: ['./geocoder-result-detail.component.scss']
})
export class GeocoderResultDetailComponent 
{
    @Input('result') public Result: GeocoderResult;
    public GeocoderStatus: any = GeocoderStatus;
    public CoordinateType: any = CoordinateType;
    public ShowDetails: boolean = false;

    constructor() 
    {
    }

    public ToggleDetails(): void
    {
        this.ShowDetails = !this.ShowDetails;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/geo/geocoder-result-detail.component.ts